import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { trackDecorationMoreButtonClick } from '../tracking';

export interface IMoreFlatsButtonProps {
  href: string;
}

export const MoreFlatsButton: React.FC<IMoreFlatsButtonProps> = ({ href }) => {
  const onClick = () => {
    trackDecorationMoreButtonClick();
  };

  return (
    <a href={href} onClick={onClick} style={{ textDecoration: 'none' }}>
      <Button theme="fill_secondary" fullWidth>
        Все квартиры с отделкой
      </Button>
    </a>
  );
};
